export enum UserProperties {
    IdentityType = 'IdentityType'
}
